import React from "react";
import { useTranslation } from "react-i18next";
import {
  panelFieldLabelClassName,
  panelGridFieldClassName,
} from "../propertyPanelUtils";

type ComputedValueProps = {
  label: React.ReactNode;
  value: number | string;
  placeholder?: string;
};

const ComputedValue: React.FC<ComputedValueProps> = ({
  label,
  value,
  placeholder = "—",
}) => {
  const { t } = useTranslation();

  return (
    <label className={panelGridFieldClassName}>
      <span className={panelFieldLabelClassName}>
        <span className="min-w-0 max-w-full">{label}</span>
      </span>
      <output className="flex h-8 flex-col justify-center rounded-sm bg-gray-100 px-1.5 text-gray-700 dark:bg-gray-800 dark:text-gray-200">
        <span className="text-sm font-semibold leading-4 tabular-nums">
          {value === "" ? placeholder : value}
        </span>
        <span className="text-[9px] font-medium leading-3 text-gray-500 dark:text-gray-400">
          {t("common.calculated")}
        </span>
      </output>
    </label>
  );
};

export default ComputedValue;
